import { Tag, Input } from 'antd';
import { BoxArrowInRight, Search } from 'react-bootstrap-icons';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import Data from '../../data/Data';

function UserList({ users }) {
    const [selectedUser, setSelectedUser] = useState(undefined);
    const [userList, setUserList] = useState(users);
    const [deleteModal, setDeleteModal] = useState(undefined);

    function handleSearch(value) {
        if (value === '')
            setUserList(users);
        else
            setUserList(users.filter(user =>
                (user.firstName + ' ' + user.lastName).toLowerCase().includes(value.toLowerCase()) ||
                user.email.toLowerCase().includes(value.toLowerCase())
            ));
    }

    function handleDeleteUser() {
        Data.deleteUser(deleteModal.id);
        setUserList(prevUsers => prevUsers.filter(user => user.id !== deleteModal.id));
        setDeleteModal(undefined);
    }

    return (
        <div className='UserList'>
            <div>
                <div className='row pe-2 mb-3'>
                    <div className='col-12 col-md-4'>
                        <Input placeholder="Search..." onChange={(e) => handleSearch(e.target.value)} suffix={<Search />} />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <div className='row table-header text-secondary pt-4 mb-2'>
                            <div className='d-none d-lg-flex col-lg-3'>Name</div>
                            <div className='col-8 col-lg-4'>Email</div>
                            <div className='col-3 col-lg-3'>Country</div>
                            <div className='d-none d-lg-flex col-lg-1'>Type</div>
                            <div className='col-2 col-lg-1'></div>
                        </div>
                    </div>
                    <div className='col-12'>
                        {userList ? userList.map(user => (
                            <div key={user.id} className={'row mb-3 element px-2' + (user.deletedAt !== null ? ' deleted-user' : '')}>
                                <div className='d-none d-lg-flex col-lg-3 align-items-center'>{user.firstName + ' ' + user.lastName}</div>
                                <div className='col-8 col-lg-4 d-flex align-items-center email'>
                                    <div className='d-lg-none'>{user.email !== null ? user.email : user.firstName + ' ' + user.lastName}</div>
                                    <div className='d-none d-lg-flex'>{user.email !== null ? user.email : ''}</div>
                                </div>
                                <div className='col-2 col-lg-3 d-flex align-items-center'>
                                    <img
                                        src={`https://hatscripts.github.io/circle-flags/flags/${user.cca2.toLowerCase()}.svg`}
                                        className='flag'
                                        width={32}
                                        alt=''
                                    />
                                    <p className='pt-3 ps-2 d-none d-lg-flex'>{user.country}</p>
                                </div>
                                {/* <div className='d-none d-lg-flex col-lg-1 align-items-center'> */}
                                    {/* <Tag color={userType === 'customer' ? '#ffaa00' : '#286f77'}>{userType[0].toUpperCase() + userType.substring(1)}</Tag> */}
                                {/* </div> */}
                                <div className='col-2 col-lg-1 py-2'>
                                    <button className='btn btn-primary btn-sm' onClick={() => setSelectedUser(user)}>
                                        <div className='d-none d-md-flex'>Details</div>
                                        <BoxArrowInRight className='d-md-none bi-box-arrow-in-right' />
                                    </button>
                                </div>
                            </div>
                        )) : (
                            <div>There are no users</div>
                        )}
                    </div>
                </div>
            </div>
            <Modal show={selectedUser !== undefined} onHide={() => setSelectedUser(undefined)} backdrop="static" keyboard={false} centered size="lg" scrollable fullscreen="sm-down">
                <Modal.Header closeButton>
                    <Modal.Title>User details</Modal.Title>
                </Modal.Header>
                <Modal.Body> {selectedUser && (
                    <div>
                        <img src={selectedUser.avatar} className='profile mb-3' alt='profile' />
                        <dl>
                            <dt>Full name</dt>
                            <dd>{selectedUser.firstName + ' ' + selectedUser.lastName}</dd>
                            <dt>Email</dt>
                            <dd>{selectedUser.email}</dd>
                            <dt>Country</dt>
                            <dd className='d-flex'>
                                <img
                                    src={`https://hatscripts.github.io/circle-flags/flags/${selectedUser.cca2.toLowerCase()}.svg`}
                                    className='flag'
                                    width={32}
                                    alt=''
                                />
                                <p className='pt-3 ps-2'>{selectedUser.country}</p>
                            </dd>
                            <dt>Type</dt>
                            <dd>
                                {/* <Tag color={selectedUser.type === 'customer' ? '#ffaa00' : '#286f77'}>{selectedUser.type[0].toUpperCase() + selectedUser.type.substring(1)}</Tag> */}
                                {selectedUser.admin && <Tag color='#ff0000'>Admin</Tag>}
                                {selectedUser.deletedAt !== null && <Tag color='#ff0000'>Deleted</Tag>}
                            </dd>
                        </dl>
                    </div>
                )}
                </Modal.Body>
                <Modal.Footer>
                    {selectedUser && selectedUser.deletedAt === null &&
                        <button className='btn btn-sm btn-outline-danger' onClick={() => {setDeleteModal(selectedUser); setSelectedUser(undefined)}}>Delete</button>
                    }
                </Modal.Footer>
            </Modal>

            <Modal show={deleteModal !== undefined} onHide={() => setDeleteModal(undefined)} backdrop="static" keyboard={false} centered size="lg" scrollable fullscreen="sm-down">
                <Modal.Header closeButton>
                    <Modal.Title>User deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure to delete {deleteModal && deleteModal.email}?
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-sm btn-danger' onClick={() => {setSelectedUser(deleteModal); setDeleteModal(undefined)}}>Cancel</button>
                    <button className='btn btn-sm btn-outline-danger' onClick={handleDeleteUser}>Delete</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default UserList;